/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

class LoggerUtil {
    /**
	 * logLevel -- 0 means no logs
	 * loglevel -- not defined or 1 means error logs (by default)
	 * loglevel -- 2 means warn and error logs
	 * loglevel -- 3 means warn, error and info logs
	 * loglevel -- 4 means warn, error, info and debug logs
	 */


    setLogLevel(logLevel) {
        this.logLevel = logLevel;
    }


    /**
	 * helper function for debug level logs
	 */

    debug(...args) {
        if (this.logLevel && this.logLevel >= 4) {
            console.debug(...args);
        }
    }

    /**
	 * helper function for error level logs
	 */

    error(...args) {
        if ((!this.logLevel) || (this.logLevel !== 0)) {
            console.error(...args);
        }
    }

    /**
	 * helper function for warn level logs
	 */

    warn(...args) {
        if (this.logLevel && this.logLevel >= 2) {
            console.warn(...args);
        }
    }

    /**
	 * helper function for info level logs
	 */

    log(...args) {
        if (this.logLevel && this.logLevel >= 3) {
            console.info(...args);
        }
    }

    info(...args) {
        if (this.logLevel && this.logLevel >= 3) {
            console.info(...args);
        }
    }
}

export default new LoggerUtil();
